Page accountPage
	title = "Mein Account"
	
	ValidationState	validationState = {}
	bool	isLoading
	bool	generalTermsAccepted, businessTermsAccepted
	bool	resetEmailSent

	show: string id = ""
		validationState.clear
		isLoading = false
		html.setTitle title + app.titleSuffix

	draw
		div display:flex, flexDirection:column, alignItems:center
			row justifyContent:end margin:{top:20 bottom:20} width:800 gap:24px
				if resetEmailSent
					div text:"E-Mail zum Ändern des Passworts versendet! Bitte prüfen Sie Ihr Postfach.", fontSize:14, color:style.okColor, textAlign:center
				else
					div text:"Passwort ändern", textDecoration:underline, cursor:pointer
						onClick:
							isLoading = true
							refresh
							try
								await backend.pb.collection('users').requestPasswordReset(app.user.email)
								resetEmailSent = true
							catch as error
								print "Password reset error:", error
							isLoading = false
							refresh
				div "Abmelden", textDecoration:underline, cursor:pointer, onClick:app.logout
			app.box width:800px
				div width:100%, display:flex, flexDirection:column, gap:16
					div tag:"h1", text:"Mein Account"
					// Account Type Section
					form.radioGroup model:app.user.claimedUserType, required:true
						options:["PrivateSeller", "BusinessSeller", "Business"]
						optionLabels:["Ich bin Privatverkäufer", "Ich bin gewerblicher Verkäufer", "Ich bin Händler"]
					
					// Contact Data Section
					row gap:16
						form.text label:"Vorname", model:app.user.firstName, width:50%, minTextLength:2, maxTextLength:50, required:true, validationState, focusInitially:true
						form.text label:"Nachname", model:app.user.lastName, width:50%, minTextLength:2, maxTextLength:50, required:true, validationState
					if app.user.claimedUserType == BusinessSeller or app.user.claimedUserType == Business
						form.text label:"Firmenname", model:app.user.businessName, width:100%, minTextLength:2, maxTextLength:100, required:true, validationState
					
					// Address Section
					form.text label:"Straße", model:app.user.streetAddress, width:100%, minTextLength:5, maxTextLength:100, required:true, validationState
					row gap:16
						form.text label:"Postleitzahl", model:app.user.zipCode, width:20%, minTextLength:4, maxTextLength:10, required:true, validationState
						form.text label:"Stadt", model:app.user.city, width:80%, minTextLength:2, maxTextLength:50, required:true, validationState
					form.text label:"Land", model:app.user.country, width:100%, minTextLength:2, maxTextLength:50, required:true, validationState
					
					// Phone Number
					form.text label:"Telefonnummer", model:app.user.phoneNumber, width:100%, minTextLength:5, maxTextLength:20, required:true, validationState
					
					// Terms
					if not app.user.generalTermsAccepted
						form.toggle model:generalTermsAccepted, label:app.getText("generalTerms"), required:true, validationState
					if app.user.claimedUserType == Business and not app.user.businessTermsAccepted
						form.toggle model:businessTermsAccepted, label:app.getText("businessTerms"), required:true, validationState

					// Business Documents
					if app.user.claimedUserType == Business
						column gap:8
							let label = "documents"
							for app.user.documents as document								
								div "📎&nbsp;&nbsp;{document}"
							html.fileInput multiple:true accept:".jpg,.jpeg,.png,.webp,.pdf"
								div width:128px height:128px border:{2px solid primaryColor} borderRadius:8 display:flex flexDirection:column alignItems:center justifyContent:center gap:8
									img Add width:48px
									div "Gewerbeschein hochladen" fontSize:12 color:#6b7280 textAlign:center
							onChange:
								await backend.users.addFiles app.user.documents, .files
									onError: alert delay:100, "Die folgenden Dateien konnten nicht hochgeladen werden:\n{.joinToString.name separator:"\n"}\n\nBitte prüfen Sie, ob die Datei ein gültiges JPEG, PNG oder PDF und nicht größer als 10 MB ist. Falls das Problem erneut auftritt, wenden Sie sich bitte an den Support."
							if validationState.shouldValidate(label):
								if not app.user.documents: validationState[label] = "Bitte laden Sie Ihren Gewerbeschein hoch."
								else                       validationState[label] = ""
							form.showErrorMessage validationState[label]
					
					// Save Button			
					div margin:{top:32}, display:flex, flexDirection:column
						app.button text:"Speichern", isDisabled:isLoading, triggerWithEnterKey:true
							onClick:
								if validationState.checkForErrorsOrEmptyFields: return
								isLoading = true
								refresh
								
								try
									let name = app.user.firstName
									if app.user.lastName: name += " " + app.user.lastName
									if app.user.businessName: name += ", " + app.user.businessName
									await backend.users.update app.user, {app.user.claimedUserType, name, app.user.firstName, app.user.lastName, app.user.businessName, app.user.phoneNumber, app.user.streetAddress, app.user.zipCode, app.user.city, app.user.country, generalTermsAccepted, businessTermsAccepted}
									
									// Send new user message to admins if not already sent
									if not app.user.newUserMessageSent
										try
											await backend.post "/api/new-user", {name, email:app.user.email, userType:app.user.claimedUserType}
											await backend.users.update app.user, {newUserMessageSent:true}
										catch as error
											print "Error sending new user message:", error
									
									isLoading = false
									validationState.clear
									app.navigateTo homePage
								catch as error
									isLoading = false
									print "Error updating user:", error
									refresh
